/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBookingPriceFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeBookingPrice, serializeBookingPricesRequest, type BookingPrice, type BookingPricesRequest, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Booking/Prices
 */
export interface PricesRequestBuilder extends BaseRequestBuilder<PricesRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BookingPrice>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: BookingPricesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<BookingPrice | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: BookingPricesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PricesRequestBuilderUriTemplate = "{+baseurl}/Booking/Prices";
/**
 * Metadata for all the requests in the request builder.
 */
export const PricesRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: PricesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBookingPriceFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeBookingPricesRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
